import {
  DetailPageNavItemSourceTableColumnDto,
  TableColumnConfigDto,
} from '@asset-metrix/portal-gateway-client-js';
import { applyFormatters, FormatterOptions } from '@asset-metrix/portal-ui';

import { formattersByType } from '../components/table/configToColDef';
import i18n from '../i18n/config';

export function formatSourceTableColumnValue(
  value: unknown,
  columnConfig: DetailPageNavItemSourceTableColumnDto | TableColumnConfigDto
): string {
  if (value === undefined || value === null) {
    return '';
  }

  const formatters = formattersByType[columnConfig.type] ?? [];

  if (formatters.length === 0) {
    return String(value);
  }

  const baseOptions: FormatterOptions = {
    dateFormat: columnConfig.dateFormat,
    digits: columnConfig.digits,
    factor: columnConfig.factor,
    postfix: columnConfig.postfix,
    disableThousandsSeparator: columnConfig.disableThousandsSeparator,
    displayFormat: columnConfig.displayFormat,
  };

  const options: FormatterOptions =
    columnConfig.type === 'text'
      ? {
          trueLabel: i18n.t('app.label.true'),
          falseLabel: i18n.t('app.label.false'),
          ...baseOptions,
        }
      : baseOptions;

  const formatted = applyFormatters(formatters, value, options);
  return formatted != null ? String(formatted) : '';
}
